import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
    Alpine.data('storeInspiringpc', function () {
        const el = $(this);
        return {
            swiperOptionThree: {
                initialSlide: 0,
                direction: 'horizontal',
                loop: true,
                autoplay: {
                  delay: 2500,
                  stopOnLastSlide: false,
                  disableOnInteraction: true,
                },
                pagination: {
                  el: '.swiper-pagination-three',
                  clickable: true,
                },
                navigation: {
                  nextEl: '.swiper-button-next-three',
                  prevEl: '.swiper-button-prev-three',
                },
                slidesPerView: 'auto',
                spaceBetween: 16,
                slidesOffsetBefore: 0,
                on: {
                  init() {
                    const swiper = this
                    swiper.el.addEventListener('mouseenter', function () {
                      swiper.autoplay.stop()
                    })
                    swiper.el.addEventListener('mouseleave', function () {
                      swiper.autoplay.start()
                    })
                  },
                },
            },
            localName: window.Shopify.locale,
            init() {
                $(function () {
                  /* 视频点击事件 */
                  $('.store-inspiring-video-player-pc').click(function () {
                    const video = $(this).siblings('.store-inspiring-video-pc').get(0)
                    $('.store-inspiring-video-pc')
                      .not(video)
                      .each(function () {
                        this.pause()
                      })
                    if (video.paused) {
                      video.play()
                      $(this).hide()
                    } else {
                      video.pause()
                      $(this).show()
                    }
                    $('.store-inspiring-video-player-pc').not(this).show()
                  })
                  /* 视频点击事件 */
                })
                this.initPC()
            }, // end init
            initPC() {
                this.initPCSwiper()
            },
            initPCSwiper() {
                new Swiper('.swiper-container-inspiring-pc', this.swiperOptionThree)
            },
        }
    })
}
document.addEventListener('alpine:init', main)